var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSparkles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.175 0H4.825A4.825 4.825 0 000 4.825v20.35A4.825 4.825 0 004.825 30h20.35A4.825 4.825 0 0030 25.175V4.825A4.825 4.825 0 0025.175 0z",
    fill: "#5560FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.175 30H15V0h10.175A4.825 4.825 0 0130 4.834v20.338A4.826 4.826 0 0125.175 30z",
    fill: "#434CCC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.166 3.615c0 3.349-5.604 8.95-8.95 8.95 3.346 0 8.95 5.601 8.95 8.948V3.615z",
    fill: "#FFD83B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.385 15.784c.45-.452.926-.876 1.427-1.27.36-.284.732-.55 1.118-.795 1.122-.711 2.243-1.165 3.184-1.165-.941 0-2.062-.443-3.184-1.166-.386-.245-.759-.51-1.118-.792-.5-.395-.977-.819-1.427-1.27-1.818-1.82-3.204-4.057-3.204-5.732v17.919c-.015-1.672 1.386-3.912 3.204-5.73z",
    fill: "#FFB24D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.186 21.309c1.948 0 5.213 3.262 5.213 5.213V16.095c0 1.963-3.265 5.214-5.213 5.214z",
    fill: "#FFD83B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4 16.095v10.427c0-1.951 3.262-5.213 5.21-5.213-1.948 0-5.21-3.25-5.21-5.214z",
    fill: "#FFB24D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSparkles);
export default __webpack_public_path__ + "static/media/Icon-sparkles.bf4c8978.svg";
export { ForwardRef as ReactComponent };